import { EditableProps } from "@builder/components/editable/editableProps";
import SidebarCollapse from "@builder/components/app/SidebarCollapse";
import Borders from "@builder/components/editable/style/Borders";
import Background from "@builder/components/editable/style/Background";
import Spacing from "@builder/components/editable/style/Spacing";
import Typography from "@builder/components/editable/style/Typography";

const Variant = ({ parent, stateMode }: EditableProps) => {
    return (
        <SidebarCollapse title="Active Variant" parent={parent}>
            <Background path={["activeInputStyles"]} stateMode={stateMode} noWrapper />
            <Borders path={["activeInputStyles"]} stateMode={stateMode} noWrapper />
            <Spacing path={["activeInputStyles"]} excluded={["margin"]} stateMode={stateMode} noWrapper />
            <Typography path={["activeInputStyles"]} excluded={["margin"]} stateMode={stateMode} noWrapper />
        </SidebarCollapse>
    );
};

export default Variant;
